import React from 'react';
import { Stack, ScrollArea, Title, Badge, Card, Text, Flex } from '@mantine/core';
import TaskCard from './TaskCard';

const KanbanColumn = ({ column, tasks, onTaskClick }) => {
    return (
        <Card withBorder  style={{flex: 1}}>
            <Flex gap="xs" justify="center" align="center" bg={column.bgColor} p={'xs'} mb={'md'} >
                <Text color={column.color}><i className={column.iconClass}></i></Text>
                <Text size="sm" fw={600} color={column.color} ta="center">
                    {column.title} {tasks.length}
                </Text>
            </Flex>
            <Stack>
                <ScrollArea scrollbarSize={2} style={{ height: 'calc(80vh - 200px)' }}>
                    <Stack spacing="sm">
                        {tasks.map((task, index) => (
                            <TaskCard
                                key={task._id || task.id || `task-${index}`}
                                task={task}
                                index={index}
                                onTaskClick={onTaskClick}
                            />
                        ))}
                    </Stack>
                </ScrollArea>
            </Stack>
        </Card>
    );
};

export default KanbanColumn;